const features = [
  {
    icon: 'ri-cloud-line',
    title: '无需下载',
    desc: '纯在线平台，打开浏览器即可畅玩，无需安装任何软件或插件，节省存储空间。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多设备支持',
    desc: '完美适配电脑、平板、手机等多种设备，数据云端同步，随时随地切换设备。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '画面流畅',
    desc: '采用先进渲染引擎，60fps高帧率运行，画面精美细腻，操作响应迅速无延迟。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    desc: 'SSL加密传输，严格隐私保护，平台合法合规运营，让您玩得放心。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            为什么选择 <span className="text-primary-500">PG模拟器</span>？
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            四大核心优势，为您带来极致的在线游戏模拟体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-6 text-center transition-all hover:scale-[1.02]"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center bg-primary-100 rounded-xl">
                <i className={`${f.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}